import { Widget } from '../../../../utils/enums/embed';
import { GalleryDisplayOptions } from '../../../components/Gallery';
import {
  STORY_DEFAULT_ANIMATIONS,
  STORY_DEFAULT_BORDER,
  STORY_DEFAULT_BORDER_COLOR,
  STORY_DEFAULT_DISPLAY,
  STORY_DEFAULT_WITH_PLAY_ICON,
  STORY_DEFAULT_WITH_RADIUS,
  STORY_DEFAULT_WITH_SHOPPABLES,
  STORY_DEFAULT_WITH_TITLE,
} from '../../../constants';
import { getFont } from '../../../utils';
import { GALLERY_DEFAULT_GAP, GALLERY_DEFAULT_JUSTIFY } from '../constants';

export const getDisplayOptions = (
  attributes: Partial<GalleryDisplayOptions>
): GalleryDisplayOptions => {
  return {
    animations: attributes.animations ?? STORY_DEFAULT_ANIMATIONS,
    border:
      attributes.border ??
      STORY_DEFAULT_BORDER[attributes.display || STORY_DEFAULT_DISPLAY],
    borderColor: attributes.borderColor ?? STORY_DEFAULT_BORDER_COLOR,
    display: attributes.display ?? STORY_DEFAULT_DISPLAY,
    font: getFont({ widget: Widget.Gallery, ...attributes }),
    gap:
      attributes.gap ??
      GALLERY_DEFAULT_GAP[attributes.display || STORY_DEFAULT_DISPLAY],
    justify: attributes.justify ?? GALLERY_DEFAULT_JUSTIFY,
    withPlayIcon: attributes.withPlayIcon ?? STORY_DEFAULT_WITH_PLAY_ICON,
    withRadius: attributes.withRadius ?? STORY_DEFAULT_WITH_RADIUS,
    withShoppables: attributes.withShoppables ?? STORY_DEFAULT_WITH_SHOPPABLES,
    withStoryTitle: attributes.withStoryTitle ?? STORY_DEFAULT_WITH_TITLE,
  };
};
